import stars from "./BG/stars.mp4"
import metro from "./BG/metro.mp4"
import triangle from "./BG/triangle.mp4"
import train from "./BG/train.mp4"

export const BACKGROUNDS = {
    Events: metro,
    Gallery: triangle,
    Sponsors: train,
    AboutUs: triangle,
    Homepage:metro,
    Login: stars,
    Signup: stars,

    Team: stars,
    Contact: triangle,
}
